export default __webpack_public_path__ + "static/media/img4.22cc58eb.jpg";